import { v1UsersBillingInfoCreate } from '@on3/api/src';
import { type IUser } from '@on3/ui-lib/api/schema/custom-contracts';
import { CreditCard } from '@on3/ui-lib/components/CreditCard';
import { Recurly } from '@on3/ui-lib/components/Subscription/Recurly';
import { useAuth } from '@on3/ui-lib/contexts/AuthProvider';
import { externalApi } from '@on3/ui-lib/utils/api';
import { CardForm } from '@public/components/Subscription/CardForm';
import { type TokenPayload } from '@recurly/recurly-js';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

import styles from './UserPaymentMethod.module.scss';

export const UserPaymentMethodModal = () => {
  const { user } = useAuth() as { user: IUser };
  const router = useRouter();
  const [state, setState] = useState<{
    success?: string;
    error?: string;
  }>({});

  const handleNewPaymentMethod = async ({ token }: { token: TokenPayload }) => {
    try {
      await v1UsersBillingInfoCreate(externalApi, +user.uid, {
        tokenId: token.id,
        primary: true,
      });

      setState({ success: 'Payment method updated successfully.' });

      router.refresh();
    } catch (error) {
      setState({ error: 'Failed to update payment method.' });
    }
  };

  return (
    <div className={styles.block}>
      <CreditCard className={styles.creditCard} />
      <h1>New payment method</h1>
      <p className={styles.description}>
        Please enter your new payment details below.
      </p>
      <Recurly>
        <CardForm
          callback={handleNewPaymentMethod}
          submitText="Save Payment Method"
        >
          {/* TODO: replace with toast notifications */}
          {state.success && <p className={styles.success}>{state.success}</p>}
          {state.error && <p className={styles.error}>{state.error}</p>}
        </CardForm>
      </Recurly>
    </div>
  );
};
